export const tabListData = [
    {
        key: 'profile',
        title: 'Profile',
    },
    {
        key: 'contacts',
        title: 'Contacts',
    },
    {
        key: 'change_password',
        title: 'Change password',
    },
    {
        key: 'passport',
        title: 'Passport',
    },
    {
        key: 'epassport',
        title: 'ePassport',
    },
    {
        key: 'tfa',
        title: 'Two-factor authentication',
    },
]
